import React from 'react'

import config from 'constants/config'
import TextLink from 'LuxKit/TextLink'
import { useIntl } from 'react-intl'

interface Props extends React.ComponentProps<typeof TextLink> {}

export default function TermsAndConditionsLink(props: Props) {
  const intl = useIntl()

  return <TextLink
    {...props}
    weight="regular"
    to={config.contentLinks.termsAndConditions.to}
    href={config.contentLinks.termsAndConditions.href}
    target="_blank"
    rel="noopener noreferrer"
  >
    {intl.formatMessage({
      id: 'DfjyzzBmwO',
      defaultMessage: 'Terms & Conditions',
      description: 'Reusable terms and conditions link text in the terms and conditions section',
    })}
  </TextLink>
}
